/* eslint-disable */
import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import { Link } from 'react-router-dom'
import qs from 'qs'
import { Button, Avatar, Table, Divider, Breadcrumb, Tooltip, message, Checkbox, Modal, Row, Col, Input, Popconfirm } from 'antd'
import ChangeBalance from '@/components/dialogs/ChangeBalance'
import TenantCreditDialog from '@/components/dialogs/TenantCreditDialog'
import { withQuery } from '@/utils'
import * as actions from '@/models/tenants/actions'
import * as services from '@/models/tenants/services'
import * as couponAction from '@/models/coupons/actions'
import * as selectors from '@/models/tenants/selectors'
import * as userSelector from '@/models/user/selectors'
import styles from './tenants.module.scss'
import TenantInfoDialog from '@/components/dialogs/tenantInfoDialog'
import PageableTable from '@/components/PageableTable'
import regions, { simplifyName } from '@/utils/regions';
import dayjs from 'dayjs'
import Filter from './filter'

function simplifyLogoName(name) {
  var shortName = name;
  var provinces = regions.provinces;
  for (var idx in provinces) {
    var pro = provinces[idx]
    if (shortName.indexOf(pro.name) != -1) {
      shortName = name.replace(pro.name, '')
    }
    var proShort = simplifyName(pro.name)
    if (shortName.indexOf(proShort) != -1) {
      shortName = shortName.replace(proShort, '')
    }
  }
  return shortName.substr(0, Math.min(4, shortName.length))
}
function getColumns({
  editEvent,
  showBalanceDialog,
  showCreditDialog,
  showCouponStatsDialog,
  isTouer,
  fetch,
  setVisibleOpPrice,
  setQuotationStart,
  setQuotationEnd,
  filters,
  offset,
  limit
}) {
  const user = useSelector(userSelector.getCurrentUser)

  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
    },
    {
      title: '名称',
      width: 260,
      render: item => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {item.logo ? (
            <Avatar shape="square" size={56} src={item.logo} style={{ marginRight: 10 }} />) :
            (
              <Avatar shape="square" size={56}
                style={{ marginRight: 10, backgroundColor: '#87d068' }}>
                {simplifyLogoName(item.name)}
              </Avatar>
            )
          }
          <div style={{ flex: 1 }}>
            <div>{item.short_name}</div>
            <div>{item.tenant_no}</div>
            <div style={{
              color: '#b2b2b2',
              lineHeight: 1.2,
              fontSize: '80%'
            }}>
              <div>{item.name}</div>
              <div style={{ marginTop: 5 }}>{item.contact_name} {item.contact_tel}</div>
            </div>
          </div>
        </div>
      )
    },
    {
      title: '备注',
      width: 140,
      render: item => item.memo,
    },
    {
      title: '自动发送客户短信',
      width: 130,
      hidden: user.get('isAdmin') ? false : true,
      render: item => {
        let checked = item.send_sms == 1 ? true : false
        return (
        <div>
          <Checkbox checked={checked} onChange={(e) => {
          let val = e.target.checked ? 1 : 0
          Modal.confirm({
            title: `${item.send_sms == 1 ? '关闭' : '开启'}自动发送客户短信`,
            content: `确定${item.send_sms == 1 ? '关闭' : '开启'}自动发送客户短信`,
            onOk() {
            services.sendSmsAuto({ id: item._id, send_sms: val }).then(res => {
              fetch({ ...filters, offset, limit })
            }).catch(err => {
              message.error(err?.message || '提交失败');
            })
            },
            onCancel() {
            },
          });
          // services
          }}>{item.send_sms == 1 ? '是' : '否'}</Checkbox>
        </div>
        )
      }
      },
    {
      title: 'openai启用',
      width: 130,
      hidden: user.get('isAdmin') ? false : true,
      render: item => {
        let checked = item.openFlag == 1 ? true : false
        return (
        <div>
          <Checkbox checked={checked} onChange={(e) => {
          let val = e.target.checked ? 1 : 0
          Modal.confirm({
            title: `${item.openFlag == 1 ? '关闭' : '开启'}openai`,
            content: `确定${item.openFlag == 1 ? '关闭' : '开启'}openai？`,
            onOk() {
            services.applyTenantOpenai(item._id).then(res => {
              fetch({ ...filters, offset, limit })
            }).catch(err => {
              message.error(err?.message || '提交失败');
            })
            },
            onCancel() {
            },
          });
          // services
          }}>{item.openFlag == 1 ? '是' : '否'}</Checkbox>
          
          {item.openFlag == 1 && (
            <div style={{ marginTop: 5 }}>
              <Button type="link" size="small" onClick={() => {
                const modal = Modal.success({
                  title: '应用信息',
                  icon: <div style={{ color: '#1890ff', fontSize: '20px', marginRight: '8px' }}>ⓘ</div>,
                  content: (
                    <div style={{ padding: '10px 0' }}>
                      <div style={{ marginBottom: 16 }}>
                        <span style={{ width: 90, color: '#666', display: 'inline-block' }}>appid:</span>
                        <span style={{ fontWeight: 'bold' }}>{item.appid || '-'}</span>
                      </div>
                      <div style={{ marginBottom: 16 }}>
                        <span style={{ width: 90, color: '#666', display: 'inline-block' }}>appsecret:</span>
                        <span style={{ fontWeight: 'bold' }}>{item.appsecret || '-'}</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24 }}>
                        <Button 
                          type="primary" 
                          style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            const copyText = `appid: ${item.appid || '-'}\nappsecret: ${item.appsecret || '-'}`;
                            
                            // 创建临时文本区域
                            const textArea = document.createElement('textarea');
                            textArea.value = copyText;
                            textArea.style.position = 'fixed';  // 避免滚动到底部
                            textArea.style.left = '-999999px';
                            textArea.style.top = '-999999px';
                            document.body.appendChild(textArea);
                            textArea.focus();
                            textArea.select();
                            
                            try {
                              const successful = document.execCommand('copy');
                              if (successful) {
                                message.success('已复制应用信息');
                              } else {
                                message.error('复制失败，请手动复制');
                              }
                            } catch (err) {
                              message.error('复制失败，请手动复制');
                              console.error('复制失败:', err);
                            }
                            
                            document.body.removeChild(textArea);
                          }}
                        >
                          复制
                        </Button>
                        <Button 
                          type="primary" 
                          style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                          onClick={() => modal.destroy()}
                        >
                          知道了
                        </Button>
                      </div>
                    </div>
                  ),
                  width: 500,
                  okButtonProps: { style: { display: 'none' } }
                });
              }}>查看应用信息</Button>
            </div>
          )}
        </div>
        )
      }
      },
	{
		title: '师傅电话商家可见',
		width: 130,
		hidden: user.get('isAdmin') ? false : true,
		render: item => {
		  let checked = item.show_worker_tel == 1 ? true : false
		  return (
			<div>
			  <Checkbox checked={checked} onChange={(e) => {
				let val = e.target.checked ? 1 : 0
				Modal.confirm({
				  title: `${item.show_worker_tel == 1 ? '关闭' : '开启'}师傅电话商家可见`,
				  content: `确定${item.show_worker_tel == 1 ? '关闭' : '开启'}师傅电话商家可见？`,
				  onOk() {
					services.seeWorkerTel({ id: item._id, show_worker_tel: val }).then(res => {
					  fetch({ ...filters, offset, limit })
					}).catch(err => {
					  message.error(err?.message || '提交失败');
					})
				  },
				  onCancel() {
				  },
				});
				// services
			  }}>{item.show_worker_tel == 1 ? '是' : '否'}</Checkbox>
			</div>
		  )
		}
	  },
    {
      title: '师傅报价商家可见',
      width: 130,
      hidden: user.get('isAdmin') ? false : true,
      render: item => {
        let checked = item.isSeeMaster == 1 ? true : false
        return (
          <div>
            <Checkbox checked={checked} onChange={(e) => {
              let val = e.target.checked ? 1 : 0
              Modal.confirm({
                title: `${item.isSeeMaster == 1 ? '关闭' : '开启'}商家自由指派模式`,
                content: `确定${item.isSeeMaster == 1 ? '关闭' : '开启'}师傅报价商家可见并可自行指派师傅？`,
                onOk() {
                  services.seeMaster({ id: item._id, isSeeMaster: val }).then(res => {
                    fetch({ ...filters, offset, limit })
                  }).catch(err => {
                    message.error(err?.message || '提交失败');
                  })
                },
                onCancel() {
                },
              });
              // services
            }}>{item.isSeeMaster == 1 ? '是' : '否'}</Checkbox>
          </div>
        )
      }
    },
    {
      title: '信用额度',
      width: 130,
      render: item => (
        <div style={{ fontSize: 13 }}>
          <div>总额: {item.total_credit.toFixed(2)}<small>元</small></div>
          <div>可用: {(item.total_credit - item.used_credits - item.locked_credits).toFixed(2)}<small>元</small></div>
          <div>已用: {item.used_credits.toFixed(2)}<small>元</small></div>
          <div>冻结: {item.locked_credits.toFixed(2)}<small>元</small></div>
        </div>
      )
    },
    {
      title: '余额',
      width: 130,
      render: item => (
        <div style={{ fontSize: 13 }}>
          <div>账户余额 {item.balance.toFixed(2)}<small>元</small></div>
          <div>可用 {(item.balance - item.locked_balance).toFixed(2)}<small>元</small></div>
          <div>已冻结 {item.locked_balance.toFixed(2)}<small>元</small></div>
        </div>
      )
    },
    {
      title: '成交率',
      width: 60,
      dataIndex: 'turnover_rate',
      render: rate => parseInt(rate * 100) + '%'
    },
    {
      title: '账单信息',
      width: 120,
      render: item => (
        <div>
          {/* <div>{{1: '本月未出', 2: '已出未结', 3: '已结算'}[item.bill_state]}</div> */}
          <div>
            {
              item.bill_state !== 10 && (
                <Link to={`/enterprises/${item._id}/bills?type=billed`}>历史账单</Link>
              )
            }
            {
              item.bill_state !== 10 && (
                <Divider type="vertical" />
              )
            }
            <Link to={`/enterprises/${item._id}/bills?type=unbilled`}>未出</Link>
          </div>
        </div>
      )
    },
    {
      title: '管理员',
      width: 120,
      render: item => (
        <div>
          {
            item.owner ? (
              <Avatar shape="square" size={42} src={item.owner.avatar} />
            ) : (
              <Avatar shape="square" size={42}>-</Avatar>
            )
          }
        </div>
      )
    },
    {
      title: '推广信息',
      width: 140,
      render: item =>
        item.referralBindings?.map(referralBinding => {
          return (
            <div>
              <div>
                <small>
                  <span>推广员: </span>
                  {referralBinding.referral?.realname}
                  {/* <Tooltip title={item.referralBinding.referral.realname}>
                  <Avatar shape="square" size={24} src={item.referralBinding.referral.user.avatar} />
                </Tooltip> */}
                </small>
              </div>
              <div>
                <small>
                  开始于: {dayjs(referralBinding.createdAt).format('YYYY-MM-DD')}
                </small>
              </div>
              <div>
                <small>
                  <Tooltip title={'最近结算时间: ' + dayjs(referralBinding.lastSettlementAt).format('YYYY-MM-DD HH:mm')}>
                    最近结算于: {dayjs(referralBinding.lastSettlementAt).fromNow()}
                  </Tooltip>
                </small>
              </div>
            </div>
          )
        })
    },
    {
      title: '操作',
      width: 200,
      render: item => (
        <div>
          <div>
            <Link to={`/enterprises/${item._id}/products`}>产品管理</Link>
            <Divider type="vertical" />
            {user.get('isAdmin') && <>
              <Link to={`/enterprises/${item._id}/employees`}>员工管理</Link>
              <Divider type="vertical" />
            </>}
            <a onClick={editEvent(`企业信息 - ${item.short_name}`, '1', item._id)}>修改</a>
          </div>
          <div>
            <a onClick={editEvent(`企业信息 - ${item.short_name}`, '2', item._id)}>企业资料</a>
            <Divider type="vertical" />
            <a onClick={showCouponStatsDialog(item)}>代金券统计</a>
          </div>
          {
            isTouer && (
              <div>
                <a onClick={showBalanceDialog(item)}>调整余额</a>
                <Divider type="vertical" />
                <a onClick={showCreditDialog(item)}>信用额度</a>
              </div>
            )
          }
          <div>
            <a onClick={() => {
              setVisibleOpPrice(item._id)
              setQuotationStart(item.quotationStart)
              setQuotationEnd(item.quotationEnd)
            }}>工单默认同意价格区间</a>
          </div>
          {user.get('isAdmin') && <>
          <div>
              <Popconfirm
                title="确定删除？"
                placement="topRight"
                onConfirm={() => {
                  services.deleteTenant(item._id).then(result => {
                    message.success('删除成功')
                    fetch({ ...filters, offset, limit })
                  }).catch(err => {
                    message.error(err.message || '发生错误')
                  })
                }}
              >
                <a>删除</a>
              </Popconfirm>
              </div>
            </>}
        </div>
      )
    }
  ].filter(item => !item.hidden)
}

function Tenants(props) {
  const dispatch = useDispatch()
  const { query, history } = props
  const prevQuery = usePrevious(query)
  const loading = useSelector(selectors.loadingSelector)
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [queryParams, setQueryParams] = useState({});
  const total = useSelector(selectors.totalSelector)
  const [filters, setFilters] = useState({})
  const [visibleOpPrice, setVisibleOpPrice] = useState('');
  const [quotationStart, setQuotationStart] = useState('');
  const [quotationEnd, setQuotationEnd] = useState('');
  const tenants = useSelector(selectors.entriesSelectors)
  const pagination = {
    showTotal: total => `共计 ${total}个 企业`,
    showQuickJumper: true
  }

  const fetch = useCallback((params = {}) => {
    params = { ...queryParams, ...params }
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setQueryParams(params)
    dispatch(actions.fetchTenantList(params))
  }, [])

  const showInfoDialog = useCallback((title, tab, tenantId) => () => {
    dispatch(actions.showInfoDialog({
      title,
      tab,
      id: tenantId
    }))
  }, [])

  const showBalanceDialog = useCallback(tenant => () => {
    dispatch(actions.showBalanceDialog({
      title: '财务调整-调整企业账户余额',
      tenant,
      typeList: [
        // {
        //   name: '线下充值',
        //   value: 'tenant/balance_recharge'
        // },
        {
          name: '手动调整余额',
          value: 'balance/adjust'
        }
      ]
    }))
  }, [])

  const showCreditDialog = useCallback(tenant => () => {
    dispatch(actions.showCreditDialog({
      title: '财务调整-信用额度',
      tenant
    }))
  }, [])

  const showCouponStatsDialog = useCallback(tenant => () => {
    dispatch(couponAction.showCouponStatsDialog({
      title: `${tenant.name}代金券统计`,
      type: 'tenant',
      id: tenant._id
    }))
  }, [])

  const handleTableChange = useCallback(params => {
    window.scrollTop = 0
    //const nextQuery = { ...filters, params }
    const nextQuery = Object.assign(filters, params);
    fetch(nextQuery)
  }, [filters])

  const filterOnChange = useCallback(params => {
    setFilters(params)
    const nextQuery = { ...filters, ...params, offset: 0 }
    fetch(nextQuery)
  }, [])

  const isTouer = useSelector(userSelector.isTour)
  const columns = getColumns({
    editEvent: showInfoDialog,
    showBalanceDialog,
    showCreditDialog,
    showCouponStatsDialog,
    isTouer,
    fetch,
    setVisibleOpPrice,
    setQuotationStart,
    setQuotationEnd,
    filters,
    offset,
    limit
  })

  useMount(() => {
    fetch(query)
  })

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>企业管理</Breadcrumb.Item>
          <Breadcrumb.Item>列表</Breadcrumb.Item>
        </Breadcrumb>
        <Button onClick={showInfoDialog('新增企业')}>新增企业</Button>
      </div>
      <Filter onChange={filterOnChange} />
      <ChangeBalance />
      <TenantCreditDialog />
      <PageableTable
        key={tenants.toJS()}
        className={styles.table}
        columns={columns}
        dataSource={tenants.toJS()}
        pagination={pagination}
        total={total}
        limit={limit}
        offset={offset}
        onChange={handleTableChange}
        loading={loading}
        scroll={{ x: '100%' }}
        defaultExpandAllRows={true}
        size="small"
        expandedRowRender={(record, index, indent, expanded) => {
          if (!Array.isArray(record?.childList) || !record?.childList.length) {
            return null;
          }

          return <Table size="small" columns={columns} dataSource={record?.childList || []} pagination={false} />;
        }}
      />
      <TenantInfoDialog />

      <Modal
        title="设置工单默认同意价格区间"
        visible={!!visibleOpPrice}
        onOk={() => {

          services.opPrice({
            id: visibleOpPrice,
            quotationStart: quotationStart,
            quotationEnd: quotationEnd
          }).then(res => {
            message.success('提交成功')
            fetch()
            setVisibleOpPrice(false)
            setVisibleOpPrice('')
            setQuotationStart('')
            setQuotationEnd('')
          }).catch(err => {
            message.error(err?.message || '提交失败');
          })
        }}
        onCancel={() => { setVisibleOpPrice(false) }}
      >
        <Row>
          <Col span={11}><Input placeholder="开始价格" value={quotationStart}
            onChange={(e) => { setQuotationStart(e.target.value) }} /></Col>
          <Col span={2}>
            <div style={{ textAlign: 'center' }}>——</div>
          </Col>
          <Col span={11}><Input placeholder="结束价格" value={quotationEnd}
            onChange={(e) => { setQuotationEnd(e.target.value) }} /></Col>
        </Row>
      </Modal>
    </div>
  )
}

export default withQuery(Tenants)
